import { render, staticRenderFns } from "./change-executor.vue?vue&type=template&id=36f318c6&scoped=true&"
import script from "./change-executor.vue?vue&type=script&lang=js&"
export * from "./change-executor.vue?vue&type=script&lang=js&"
import style0 from "./change-executor.vue?vue&type=style&index=0&id=36f318c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f318c6",
  null
  
)

export default component.exports